import { Skeleton } from "@/components/ui/skeleton";

/**
 * Public shell skeleton — mirrors PublicLayout (header + main + footer).
 * Used as the top-level Suspense fallback when navigating into / between
 * public routes before the layout is mounted.
 */
export function PublicShellSkeleton({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <div className="min-h-screen flex flex-col bg-light-gray dark:bg-surface">
      {/* Header */}
      <header className="sticky top-0 z-10 flex h-16 items-center justify-between border-b border-outline-variant/10 bg-surface-container-lowest/80 px-4 backdrop-blur dark:bg-surface-container/80 tablet:px-8">
        <div className="flex items-center gap-3">
          <Skeleton className="h-10 w-10 rounded-lg" />
          <Skeleton className="h-5 w-40" />
        </div>
        <div className="hidden items-center gap-6 tablet:flex">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="h-4 w-20" />
          ))}
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-9 rounded-full" />
          <Skeleton className="h-9 w-24 rounded-full" />
        </div>
      </header>

      {/* Page content */}
      <main className="flex-1 px-4 py-8 tablet:px-8 lg:px-12">{children}</main>

      {/* Footer */}
      <footer className="border-t border-outline-variant/10 bg-surface-container-lowest px-4 py-10 dark:bg-surface-container tablet:px-8">
        <div className="grid grid-cols-2 gap-8 tablet:grid-cols-4">
          {Array.from({ length: 4 }).map((_, col) => (
            <div key={col} className="space-y-3">
              <Skeleton className="h-4 w-24" />
              {Array.from({ length: 4 }).map((_, row) => (
                <Skeleton key={row} className="h-3 w-32" />
              ))}
            </div>
          ))}
        </div>
      </footer>
    </div>
  );
}
